import React from 'react';
import { useSelector } from 'react-redux';
// import './FullPageLoader.css'; // Add CSS for styling

const FullPageLoader = () => {
    const isLoading = useSelector((state) => state.loader.isLoading); // Listen to global loader state

    if (!isLoading) return null; // Do not render if not loading

    return (
        <div className="loader-mask-wrapper">
            <div className="loader-mask">
                {/* Loader is styled via CSS */}
            </div>
        </div>
    );
};

export default FullPageLoader;
